var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55127 17.4887C8.69746 17.7419 8.90772 17.9521 9.16091 18.0983C9.41411 18.2445 9.70131 18.3214 9.99367 18.3214C10.286 18.3214 10.5732 18.2445 10.8264 18.0983C11.0796 17.9521 11.2899 17.7419 11.4361 17.4887",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71661 12.7634C2.60781 12.8827 2.53602 13.031 2.50995 13.1902C2.48389 13.3495 2.50468 13.513 2.56979 13.6607C2.6349 13.8084 2.74154 13.934 2.87672 14.0222C3.0119 14.1104 3.1698 14.1574 3.33121 14.1575H16.6559C16.8173 14.1576 16.9753 14.1107 17.1105 14.0227C17.2458 13.9347 17.3526 13.8092 17.4179 13.6616C17.4831 13.514 17.5041 13.3506 17.4783 13.1913C17.4524 13.032 17.3808 12.8836 17.2722 12.7643C16.1646 11.6225 14.9904 10.4091 14.9904 6.66236C14.9904 5.33714 14.4639 4.06619 13.5268 3.12911C12.5898 2.19203 11.3188 1.66559 9.99358 1.66559C8.66835 1.66559 7.3974 2.19203 6.46032 3.12911C5.52325 4.06619 4.9968 5.33714 4.9968 6.66236C4.9968 10.4091 3.82173 11.6225 2.71661 12.7634Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.00112a37b34cc68d6b6fec1a4563471c.svg";
export { ForwardRef as ReactComponent };